<script>
import { onMount } from "svelte";
import { turpial } from "../../libraries/turpial";


export let ClassInput = "formElements";
export let name = "";
export let checked = false;
export let on_change = function(){};
export let classes = "";

let id = "switch-"+turpial.random_string(5);

/**
 * @type HTMLElement
 */
let container = null;


onMount(()=>{
    let input = container.querySelector("input[type='checkbox']");
    input.classList.add("switch");
    input.classList.add("is-rounded");
    input.dataset.boolean = true;
    input.id = id;
})

</script>
<switch-input class="field {$$slots.label1 || $$slots.label2 ? 'flex-center is-gap-10' : ''} {classes} is-relative" bind:this={container}>
    {#if $$slots.label1}
        <slot name="label1" id={id}></slot>
    {/if}

    <slot></slot> 
    
    {#if !$$slots.default}
        <input id={id} type="checkbox" on:change="{(e)=>{ on_change(e); }}" class="switch is-rounded {ClassInput}" name={name} data-boolean="true" bind:checked={checked}>
    {/if}

    {#if $$slots.label2}
        <slot name="label2" id={id}></slot>      
    {/if}

    <label for="{id}" class="is-block mb-0 {$$slots.label1 || $$slots.label2 ? 'is-hidden' : ''}"></label>    
</switch-input>
<style>
label{
    padding-left: 3rem !important;
}
switch-input .field :global(.switch[type=checkbox]+label:after){
    top: 1px !important;
}
switch-input:not(:last-child){
    margin-bottom: 0;
}
switch-input.is-small{
    zoom: 0.8;
}
switch-input.is-extra-small{
    zoom: 0.6;
}
</style>